var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#FFF1E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3303 17.8854L13.6517 18.6517C13.1272 19.1761 12.459 19.5333 11.7316 19.6779C11.0042 19.8226 10.2502 19.7484 9.56494 19.4646C8.87971 19.1807 8.29404 18.7001 7.88199 18.0834C7.46993 17.4667 7.25 16.7417 7.25 16C7.25 15.2583 7.46993 14.5333 7.88199 13.9166C8.29404 13.2999 8.87971 12.8193 9.56494 12.5355C10.2502 12.2516 11.0042 12.1774 11.7316 12.3221C12.459 12.4668 13.1272 12.8239 13.6517 13.3484L18.3483 18.6517C18.8728 19.1761 19.541 19.5333 20.2684 19.6779C20.9958 19.8226 21.7498 19.7484 22.4351 19.4646C23.1203 19.1807 23.706 18.7001 24.118 18.0834C24.5301 17.4667 24.75 16.7417 24.75 16C24.75 15.2583 24.5301 14.5333 24.118 13.9166C23.706 13.2999 23.1203 12.8193 22.4351 12.5355C21.7498 12.2516 20.9958 12.1774 20.2684 12.3221C19.541 12.4668 18.8728 12.8239 18.3483 13.3484L17.6697 14.1146",
    stroke: "#FAA037",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.c47146a608b656f2907b8395272387d3.svg";
export { ForwardRef as ReactComponent };